import { cn, Icon, type MarketIconSymbol, Typography } from "@kyan/ui";

import { MarginRatio } from "#/components/MarginRatio/MarginRatio";
import { type CompactAccountState } from "#/types/accounts";
import { type PortfolioSymbol } from "#/types/markets";
import { formatCurrency } from "#/utils/valueFormatters";

interface PortfolioRiskItemProps {
  accountState: CompactAccountState;
  underlying: PortfolioSymbol;
  isUSDCUnderlying: boolean;
}

export const PortfolioRiskItem: React.FC<PortfolioRiskItemProps> = ({
  accountState,
  underlying,
  isUSDCUnderlying,
}) => {
  return (
    <div
      className={cn("flex w-full gap-2", {
        "items-center justify-between pr-6": isUSDCUnderlying,
      })}
    >
      <Icon
        name={underlying.toLowerCase() as MarketIconSymbol}
        className={cn(
          "text-textPrimary -ml-1 flex size-6 items-center justify-center",
        )}
      />
      <div
        className={cn("flex-1 place-items-start gap-0.5", {
          grid: !isUSDCUnderlying,
          "flex w-full justify-between": isUSDCUnderlying,
        })}
      >
        <Typography
          className={cn({
            block: isUSDCUnderlying,
          })}
        >
          {isUSDCUnderlying ? "Unallocated USDC" : `${underlying} Portfolio`}
        </Typography>
        <Typography>{formatCurrency(accountState.equity)}</Typography>
      </div>
      {!isUSDCUnderlying && (
        <div className="grid gap-1">
          <MarginRatio type="IMr" value={accountState.imr} />
          <MarginRatio value={accountState.mmr} />
        </div>
      )}
    </div>
  );
};
